import * as ObservationActions from './observation.actions';
import { createReducer, on } from '@ngrx/store';
import { Observation } from '../../models/observation';

export interface State {
  observations: Observation[];
  count: number;
  selectedObservation: Observation | null;
  lastCreatedObservation: Observation | null;
  loading: boolean;
  error: any;
}

const initialState: State = {
  observations: [],
  count: 0,
  selectedObservation: null,
  lastCreatedObservation: null,
  loading: false,
  error: null,
};

export const observationReducer = createReducer(
  initialState,
  on(ObservationActions.fetchObservations, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ObservationActions.fetchObservationsSuccess, (state, { observations, count }) => ({
    ...state,
    observations: observations,
    count: count,
    loading: false,
    error: null,
  })),
  on(ObservationActions.fetchObservationsFail, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(ObservationActions.fetchObservation, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ObservationActions.fetchObservationSuccess, (state, { observation }) => ({
    ...state,
    selectedObservation: observation,
    loading: false,
    error: null,
  })),
  on(ObservationActions.fetchObservationFail, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(ObservationActions.addObservation, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ObservationActions.addObservationSuccess, (state, { observation }) => ({
    ...state,
    observations: [...state.observations, observation],
    lastCreatedObservation: observation,
    loading: false,
    error: null,
  })),
  on(ObservationActions.addObservationFail, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(ObservationActions.updateObservation, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ObservationActions.updateObservationSuccess, (state, { payload }) => ({
    ...state,
    observations: state.observations.map((observation) =>
      +(observation.id ?? -1) === +payload.id ? payload.newObservation : observation
    ),
    selectedObservation: payload.newObservation,
    loading: false,
    error: null,
  })),
  on(ObservationActions.updateObservationFail, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(ObservationActions.deleteObservation, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ObservationActions.deleteObservationSuccess, (state, { payload }) => ({
    ...state,
    observations: state.observations.filter((observation) => observation.id !== payload),
    loading: false,
    error: null,
  })),
  on(ObservationActions.deleteObservationFail, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(ObservationActions.clearSelectedObservation, (state) => ({
    ...state,
    selectedObservation: null,
  }))
);
